export const cookieMapper = {
  analytics: ['_ga', '_gcl_au', '_gid', 'SL_C_', 'Gdyn'],
  marketing: [
    'c_user',
    'datr',
    'dpr',
    'fr',
    'sb',
    'spin',
    'xs',
    '_fbp',
    'DSID',
    'IDE',
    'APNUID',
    'KADUSERCOOKIE',
    'cmppersisttestcookie',
    'cmpupdatedialogopendate',
    'euconsent-v2',
    'ps',
    'sid',
    'szncsr',
    'lms_analytics',
    'lidc',
    'UserMatchHistory',
    'li_mc',
    'lang',
    'bcookie',
    'sdsc',
    'li_gc',
    'li_sugr',
    'AnalyticsSyncHistory',
    'liap',
    'lms_ads',
    'didomi_token',
    'didomi_accept_cookie'
  ],
  functional: ['YSC', 'CONSENT', 'LOGIN_INFO', 'VISITOR_INFO1_LIVE']
};
